export default __webpack_public_path__ + "static/Mountrail-9dc384844afe45911cca23e5209cbc64.pdf";